import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ReaderNavigationItem from './new_ReaderNavigationItem'
import { getNavigationToolbarData } from '../actions'

class ReaderNavigation extends React.Component {
  static propTypes = {
    sectionTitle: PropTypes.string.isRequired,
    chapterID: PropTypes.string.isRequired,
    pageID: PropTypes.string.isRequired,
    displaySectionNumbers: PropTypes.bool.isRequired,
    pageroot: PropTypes.string.isRequired,
    getNavigationToolbarData: PropTypes.func.isRequired,
    overallPercentComplete: PropTypes.number.isRequired, // all refs of this need to be removed once the switch to the new reader is made
    navigationToolbarRows: PropTypes.array.isRequired,
  }

  UNSAFE_componentWillMount() {
    this.props.getNavigationToolbarData(this.props.chapterID, this.props.pageID)
  }

  componentDidMount() {
    let store = window.MyEdAnalyticsStore
    let state
    if (store) {
      state = store.getState()
      store.subscribe(() => {
        state = store.getState()
      })
    }
    $('#reader_layout').powerTimer({
      sleep: state.ANALYTICS_SYNC_RATE ? state.ANALYTICS_SYNC_RATE : 30000,
      name: 'retrieve_new_analytics',
      func: () => {
        if (
          state.analyticsUpdated !== undefined ? state.analyticsUpdated : true
        ) {
          this.props.getNavigationToolbarData(
            this.props.chapterID,
            this.props.pageID
          )
        }
      },
    })
  }

  render() {
    return (
      <div className="card shadow mt-3">
        <div className="card-header bg-light-gray font-title">
          {this.props.sectionTitle}
        </div>
        <ul
          id="toolbar_item_list"
          className="nav nav-list list-group list-group-flush font-title mb-3"
        >
          {this.props.navigationToolbarRows.map(toolbarRow => {
            return (
              <ReaderNavigationItem
                key={toolbarRow.node}
                toolbarRow={toolbarRow}
                displaySectionNumbers={this.props.displaySectionNumbers}
                pageroot={this.props.pageroot}
              />
            )
          })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    overallPercentComplete:
      state.navigationToolbarData.sectionTitleInfo.overallPercentComplete,
    sectionTitle: state.navigationToolbarData.sectionTitleInfo.sectionTitle,
    navigationToolbarRows: state.navigationToolbarData.navigationToolbarRows,
    pageroot: state.navigationToolbarData.sectionTitleInfo.pageroot,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getNavigationToolbarData: (chapterID, pageID) => {
      dispatch(getNavigationToolbarData(chapterID, pageID))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReaderNavigation)
